export const MEMBERSHIP_STATUS = {
    PENDING_PAYMENT: 1,
    PENDING_APPROVAL: 2,
    ACTIVE: 3,
    UPCOMING_RENEWAL: 4,
    EXPIRED: 5,
    LAPSE: 6,
    DEREGISTERED_REMOVAL_DEATH: 7,
    REMOVAL_DEATH: 8,
    ALL_AVAILABLE: 9,
};

export const MEMBERSHIP_STATUS_TAB = [
    {
        name: "ALL",
        type: MEMBERSHIP_STATUS.ALL_AVAILABLE,
    },
    {
        name: "Payment Pending",
        type: MEMBERSHIP_STATUS.PENDING_PAYMENT,
    },
    {
        name: "Pending Approval",
        type: MEMBERSHIP_STATUS.PENDING_APPROVAL,
    },
    {
        name: "Active",
        type: MEMBERSHIP_STATUS.ACTIVE,
    },
    {
        name: "Upcoming Renewal",
        type: MEMBERSHIP_STATUS.UPCOMING_RENEWAL,
    },
    {
        name: "Expired",
        type: MEMBERSHIP_STATUS.EXPIRED,
    },
    {
        name: "Lapse",
        type: MEMBERSHIP_STATUS.LAPSE,
    },
    {
        name: "Deregistered / Removal Death",
        type: MEMBERSHIP_STATUS.DEREGISTERED_REMOVAL_DEATH,
    },
];

export const PROFILE_INFORMATION = {
    BASIC_INFORMATION: 1,
    ACADEMIC_QUALIFICATIONS: 2,
    WORKING_EXPERIENCE: 3,
    CERTIFICATES: 4,
};

export const PROFILE_INFORMATION_TABS = [
    {
        name: "Basic Information",
        type: PROFILE_INFORMATION.BASIC_INFORMATION,
    },
    {
        name: "Academic Qualifications",
        type: PROFILE_INFORMATION.ACADEMIC_QUALIFICATIONS,
    },
    {
        name: "Technical Competencies",
        type: PROFILE_INFORMATION.WORKING_EXPERIENCE,
    },
    {
        name: "Certificates",
        type: PROFILE_INFORMATION.CERTIFICATES,
    },
];

export const PreferredRegistration = {
    PROFESSIONAL_TECHNOLOGIST: 3,
    CERTIFIED_TECHNICIAN: 4,
};

export const CertificateTypeStrings = {
    [PreferredRegistration.PROFESSIONAL_TECHNOLOGIST]: "Professional Technologist",
    [PreferredRegistration.CERTIFIED_TECHNICIAN]: "Certified Technician",
};
